import React from 'react';
import DateRangeTrigger from './DateRangeTrigger';
import DateRangePopover from './DateRangePopover';
import useDateRangePicker from './useDateRangePicker';

export {
  formatDateString,
  parseRangeString,
  computeInitialDates,
  computeMinMaxDates,
  computeStaticRanges,
  clampSelectionToDateThresholdsAndMaxSpan,
  clampSelectionToMaxDays,
} from './dateRangeUtils';

export { useDateRangePicker };

const DateRangePickerInput = (props) => {
  const { className = '', style = {} } = props;
  const {
    containerRef,
    isOpen,
    draftRange,
    minDate,
    maxDate,
    effectiveStaticRanges,
    displayLabel,
    handleTogglePopover,
    handleConfirmSelection,
    handleDraftSelectionChange,
  } = useDateRangePicker(props);

  return (
    <div className={`position-relative ${className}`} ref={containerRef} style={style}>
      <DateRangeTrigger
        displayLabel={displayLabel}
        isOpen={isOpen}
        onToggle={handleTogglePopover}
      />

      {isOpen && (
        <DateRangePopover
          selectedRange={draftRange}
          onSelectionChange={handleDraftSelectionChange}
          minDate={minDate}
          maxDate={maxDate}
          staticRanges={effectiveStaticRanges}
          onClose={handleConfirmSelection}
        />
      )}
    </div>
  );
};

export default DateRangePickerInput;
